/*
 * @Author: 张印 hbzyin@163.com
 * @FilePath: /mall-fe/src/pages/product/list.tsx
 * @Description: 商品详情页列表路由组件
 */
import ProductList from 'views/ProductList';
import ProductListWeb from 'views/web/product/List';
import { MediaQueryContext } from 'libs/contexts';
import { useContext } from 'react';
import { allSettled, isMobileMall } from 'libs/utils';
import { SorterOrder } from 'comps/ListRuleBar';
import jsurl from 'jsurl';
import { apiGetProductList, apiGetManufacturerSupplyAgreement } from 'api/mall';
import { GetServerSideProps } from 'next';
import { ProductListNetPriceContextProvider } from 'libs/contexts';

export default function ProductListPage(props) {
  const { isMobile } = useContext(MediaQueryContext);
  return (
    <ProductListNetPriceContextProvider>
      {isMobile ? <ProductList /> : <ProductListWeb {...props} />}
    </ProductListNetPriceContextProvider>
  );
}

export const getServerSideProps: GetServerSideProps = async (ctx: any) => {
  const serverHeaders = ctx.req.headers;
  if (!isMobileMall(ctx?.req)) {
    let params = {};
    try {
      params = jsurl.parse(ctx.query.params) || {};
    } catch (error) {
      console.log('params', error);
      params = {};
    }

    let attributeNames = '';
    let attributeValues = '';
    let defaultKey = '';
    params.spuAttributeList?.forEach((v: { name: 'string'; values: any }) => {
      const arr = v.values?.map(() => v.name) || [];
      const valArr = v.values?.map((val) => val?.name || val) || [];
      attributeNames += arr.join(',');
      attributeValues += valArr?.join(',');
    });
    const brandSysNoList = params?.brands?.map((v) => v.sysNo);
    params.upstreamSupplierSysNoList = Array.isArray(params.upstreamSupplierSysNoList)
      ? params.upstreamSupplierSysNoList.join(',')
      : params.upstreamSupplierSysNoList || null;
    let agreementList = null;
    if (ctx.query.supplierId) {
      const result = await apiGetManufacturerSupplyAgreement({
        serverSide: true,
        headers: serverHeaders,
        query: {
          supplierSysNo: ctx.query.supplierId,
        },
      });
      agreementList = result?.data || [];
    }
    if (
      !ctx.query.params &&
      !ctx.query.greenType &&
      !ctx.query.selefBrandType &&
      !ctx.query.catId &&
      !ctx.query.supplierId &&
      !ctx.query.shopId
    ) {
      defaultKey = '钢筋';
    }
    const apiList = [
      apiGetProductList({
        serverSide: true,
        headers: serverHeaders,
        json: {
          greenType: ctx.query.greenType || null,
          selefBrandType: ctx.query.selefBrandType || null,
          catId: ctx.query.catId || null,
          key: ctx.query.key || params.keyword || defaultKey,
          minPrice: params.priceRangeLow || null,
          maxPrice: params.priceRangeHigh || null,
          sortField: params.sorts?.length ? params.sorts[0].sortField : 'totalScore',
          orderBy: params.sorts?.length ? params.sorts[0].orderBy : SorterOrder.DESC,
          attributeNames: attributeNames || null,
          attributeValues: attributeValues || null,
          brandIds: brandSysNoList?.join(',') || null,
          brandSysNoList: brandSysNoList || null,
          agreementList,
          supplyFlag: !!ctx.query.supplierId, // 是否是厂家直采
          shopSysNo: ctx.query.shopId || null,
          pageNo: 1,
          pageSize: 30,
          ...params,
        },
      }),
    ];
    const allData = await allSettled(apiList);
    const [productListRes] = allData;
    const productListData = productListRes.data?.data || {};
    // if (productListData?.spuList?.pageSize === 600) {
    //   productListData.spuList.pageSize = params.pageSize || 30;
    // }
    return {
      props: {
        productListData,
        // categories: categoryRes.data?.data?.categories || [],
        // productDetail: productDetailRes.data?.data || {},
      },
    };
  }
  return {
    props: {},
  };
};
